import { render, staticRenderFns } from "./sports-fever-360.vue?vue&type=template&id=8ac13d6c&scoped=true&"
var script = {}
import style0 from "./sports-fever-360.vue?vue&type=style&index=0&id=8ac13d6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ac13d6c",
  null
  
)

export default component.exports